import type { SymbolKey } from '@/entities/symbol';

export const CHART_HEIGHT = 400;

export interface PreviewChartProps {
  symbols: SymbolKey[];
  showLegend?: boolean;
  isLightMode?: boolean;
  from?: string;
  symbolLimit?: number;
}
